'use strict';

var ModuleName = 'AcaApp';

angular.module(ModuleName, [
  'ngRoute',
  'ngResource',
  'ngMessages',
  'md.data.table',
  'ngMaterial',
  'luegg.directives',
  'angular-loading-bar'
]).run([
  '$window',
  '$http',
  '$rootScope',
  '$location',
  'AuthenticationService',
  'LayoutService',
  'AuxiliaryDataService',
  'UtilsService',
  'SendService',
  '$mdDialog',
  //jscs:disable maximumLineLength
  function($window, $http, $rootScope, $location, AuthenticationService, LayoutService, AuxiliaryDataService, UtilsService, SendService, $mdDialog){
    $http.defaults.headers.common.Authorization = $window.sessionStorage.token;
    var urisWithoutSecurity = [
      '/login',
      '/forgot-password',
      '/create-account',
      '/reset-password',
      '/account-locked',
      '/invalid-session',
      '/cliend-disabled'
    ];
    var mfaValidUris = [
      '/add-phone',
      '/send-mfa'
    ];
    /*jshint unused:false */
    $rootScope.$on('$routeChangeStart', function(event, nextLocation, currentLocation){
      $mdDialog.hide();
      var nextPath = (nextLocation.$$route) ? nextLocation.$$route.originalPath : undefined;
      var currentPath =
        (currentLocation !== undefined && currentLocation.$$route) ? currentLocation.$$route.originalPath : undefined;
      if(_.contains(urisWithoutSecurity, nextPath)){
        if(currentPath && nextPath === '/login'){
          if(AuthenticationService.isUserLoggedIn()){
            $location.path(currentPath);
            return;
          }
        }
        LayoutService.setBodyByDefault(currentPath, nextPath);
        $location.path(nextPath);
        return;
      }
      if(currentPath === '/login'){
        if(_.contains(mfaValidUris, nextPath) && $window.sessionStorage.MFAEnabled){
          if(!($window.sessionStorage.profile === 'CNV_ACASOVOS') || !($window.sessionStorage.MFAEnabled === 'null' && $window.sessionStorage.profile !== 'CNV_ACAADMIN')){
            LayoutService.setBodyByDefault(currentPath, nextPath);
            $location.path(nextPath);
            return;
          }else{
            $location.path(currentPath);
            return;
          }
        }
      }
      if(currentPath !== '/login' && _.contains(mfaValidUris, nextPath) && $window.sessionStorage.MFAEnabled){
        LayoutService.setBodyByDefault(currentPath, nextPath);
        if(_.contains(mfaValidUris, currentPath) && $window.sessionStorage.phoneNumber !== 'null'){
          if(((currentPath === '/send-mfa' && nextPath === '/add-phone')  || currentPath === '/add-phone') && $window.sessionStorage.fromAddPhone !== 'true'){
            $location.path(currentPath);
            return;
          }
          $location.path(nextPath);
          return;
        }
        $location.path(currentPath);
        return;
      }
      if(_.contains(mfaValidUris, currentPath) && !$rootScope.userVerified){
        $location.path(currentPath);
        return;
      }
      if(currentPath === '/records'){
        $location.path(currentPath).search({});
      }
      LayoutService.setBodyByDefault(currentPath, nextPath);
      if($window.sessionStorage.expiredPassword === 'true'){
        $location.path('/expired-password');
      }
      else{
        if(AuthenticationService.isUserLoggedIn() && $window.sessionStorage.eulaAccepted === 'false'){
          $location.path('/license-agreement');
        }
        else{
          if(AuthenticationService.isUserLoggedIn()){
            if($window.sessionStorage.MFAEnabled === 'N'){
              AuxiliaryDataService.LoadCountryList();
            }
            $location.path(nextPath || '/home');
          }
          else{
            $location.path('/login');
          }
        }
      }
    });
    if(AuthenticationService.isUserLoggedIn()){
      AuthenticationService.setSessionInterval();
    }
  }
]);

angular.module(ModuleName)
  .config([
    '$httpProvider',
    function($httpProvider){
      $httpProvider.interceptors.push('SessionInjectorService');
    }
  ])
  .config(['cfpLoadingBarProvider',
      function(cfpLoadingBarProvider){
        cfpLoadingBarProvider.excludeURL = ['html/rfm/upload.html', '/api/notification'];
        cfpLoadingBarProvider.excludeRPC =
          [
            'FindJob',
            'ImportResults',
            'ResetCurrentData',
            'CallImportLrj',
            'RenewToken',
            'RunBatchPrintLrj',
            'CallXmit'
          ];
        cfpLoadingBarProvider.latencyThreshold = 50;
        cfpLoadingBarProvider.autoIncrement = false;
        cfpLoadingBarProvider.spinnerTemplate =
        '<div class="lock-screen-container" ng-show="lockedScreen.isLoading"> ' +
          '<div class="lock-screen-item lock-screen-item--top"></div> ' +
          '<div class="lock-screen-item center-content"> ' +
            '<div class="loading-spinner loader"> ' +
              '<div id="circularG"> ' +
                '<div id="circularG_1" class="circularG"></div> ' +
                '<div id="circularG_2" class="circularG"></div> ' +
                '<div id="circularG_3" class="circularG"></div> ' +
                '<div id="circularG_4" class="circularG"></div> ' +
                '<div id="circularG_5" class="circularG"></div> ' +
                '<div id="circularG_6" class="circularG"></div> ' +
                '<div id="circularG_7" class="circularG"></div> ' +
                '<div id="circularG_8" class="circularG"></div> ' +
              '</div> ' +
            '</div> ' +
          '</div> ' +
          '<div class="lock-screen-item lock-screen-item--bottom"></div> ' +
        '</div>';
      }
  ]);
